<div class="header-container">
  <div>
  </div>
  <div class="header-spacer"></div>
  <div>
    <button [routerLink]="'/pharmacy-management/add-drug-interaction'" mat-raised-button color="accent">
      <mat-icon>add</mat-icon> Add Drug-to-Drug Interaction
    </button></div>
</div>

<div *ngIf="!drugInteractionDataSource" class="center-container">
  <mat-spinner></mat-spinner>
</div>

<div *ngIf="drugInteractionDataSource" class="mat-elevation-z8 table-container">
  
  <table mat-table multiTemplateDataRows [dataSource]="drugInteractionDataSource" #drugInteractionSort="matSort"
         matSort (matSortChange)="sortData($event)">
    
    <ng-container matColumnDef="icons">
      <th *matHeaderCellDef mat-header-cell></th>
      <td *matCellDef="let row" mat-cell>
        <mat-icon class="table-icon" #editDrugInteractionTooltip="matTooltip"
                  matTooltip="EDIT Drug Interaction" (click)="editEntry($event, row.interactionId)">edit
        </mat-icon>
        <mat-icon class="table-icon" #deleteDrugInteractionTooltip="matTooltip"
                  matTooltip="DELETE Drug Interaction" (click)="deleteEntry($event, row.interactionId)">delete
        </mat-icon>
      </td>
    </ng-container>
    
    <ng-container matColumnDef="interactionId">
      <th *matHeaderCellDef mat-header-cell mat-sort-header> ID</th>
      <td *matCellDef="let row" mat-cell> {{row.interactionId}}</td>
    </ng-container>
    
    <ng-container matColumnDef="drugInteractionCategoryA">
      <th *matHeaderCellDef mat-header-cell> Category A</th>
      <td *matCellDef="let row" mat-cell> {{row.drugInteractionCategoryA.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="drugInteractionCategoryB">
      <th *matHeaderCellDef mat-header-cell> Category B</th>
      <td *matCellDef="let row" mat-cell> {{row.drugInteractionCategoryB.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="documentation">
      <th *matHeaderCellDef mat-header-cell> Documentation</th>
      <td *matCellDef="let row" mat-cell> {{row.documentation.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="management">
      <th *matHeaderCellDef mat-header-cell> Management</th>
      <td *matCellDef="let row" mat-cell> {{row.management.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="onset">
      <th *matHeaderCellDef mat-header-cell> Onset</th>
      <td *matCellDef="let row" mat-cell> {{row.onset.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="severity">
      <th *matHeaderCellDef mat-header-cell> Severity</th>
      <td *matCellDef="let row" mat-cell> {{row.severity.name}}</td>
    </ng-container>
    
    <ng-container matColumnDef="expandedDetail">
      <td *matCellDef="let row" mat-cell [attr.colspan]="drugInteractionDisplayedColumns.length">
        <div class="row-detail-container"
             [@detailExpand]="row == drugInteractionExpandedRow ? 'expanded' : 'collapsed'">
          <b>Created By: </b>{{row.createdBy}}<br>
          <b>Created Date: </b>{{row.created | date: dateTimeFormat}}<br>
          <b>Updated By: </b>{{row.updatedBy}}<br>
          <b>Updated Date: </b>{{row.updated | date: dateTimeFormat}}<br>
        </div>
      </td>
    </ng-container>
    
    <tr mat-header-row *matHeaderRowDef="drugInteractionDisplayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: drugInteractionDisplayedColumns;" class="row"
        [class.expanded-row]="drugInteractionExpandedRow == row"
        (click)="drugInteractionExpandedRow = drugInteractionExpandedRow === row ? null : row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail'];" class="detail-row"></tr>
  
  </table>
  
  <mat-paginator #drugInteractionPaginator (page)="pageChanged($event)"
                 [length]="drugInteractionTableControl.length" [pageSize]="drugInteractionTableControl.pageSize"
                 [pageIndex]="0" [pageSizeOptions]="drugInteractionTableControl.pageSizeOptions">
  </mat-paginator>

</div>
